import React from 'react';
import { sprintf } from 'sprintf-js';
import styled, { css } from 'styled-components';

import { Box } from 'components/Box';
import { PostListingLink } from 'components/Post/PostListingLink';
import { Link as RouterLink } from 'components/RouterLink';
import { Text } from 'components/Text';
import { UserNotification } from 'components/UserNotification';
import { colors, fontWeights } from 'theme';
import { trackClicked } from 'utils/analytics';

const linkStyles = css`
  text-decoration: underline;
  white-space: nowrap;
  font-weight: ${fontWeights.semiBold};
`;

const StyledRouterLink = styled(RouterLink)`
  ${linkStyles}
`;

const StyledPostListingLink = styled(PostListingLink)`
  ${linkStyles}
`;

type Props = {
  dismiss: () => void;
};

export function PageHeaderAtsCtaNotification({ dismiss }: Props) {
  return (
    <Box p={12} minWidth={260} borderTop={`1px solid ${colors.aluminum}`}>
      <UserNotification status="NEW" dismiss={dismiss}>
        <Text
          dangerouslySetInnerHTML={{
            __html: sprintf(
              getText(`One more reason to post on Idealist:
              Try%(nonBreakingSpace)sour free Applicant Tracker%(nonBreakingSpace)stoday!`),
              {
                nonBreakingSpace: '&nbsp;',
              }
            ),
          }}
        />

        <Box display="flex" mt={16}>
          <StyledRouterLink
            to={getText('/applicant-tracker')}
            onClick={dismiss}
          >
            {getText('Learn More')}
          </StyledRouterLink>

          <Box mx="8px" width="1px" bg={colors.aluminum} />

          <StyledPostListingLink
            data-qa-id="post-a-listing-ats-dropdown"
            onClick={() => {
              trackClicked('Post A Listing', {
                context: 'User Dropdown ATS CTA',
              });
              dismiss();
            }}
          >
            {getText('Post a Listing')}
          </StyledPostListingLink>
        </Box>
      </UserNotification>
    </Box>
  );
}
